export function assert(test?: boolean, message?: string, ...optionalParams: unknown[]) {
  // eslint-disable-next-line no-console
  console.assert(test, message, ...optionalParams);
}
